import SanityBlockContent from '~/components/sanity/SanityBlockContent.vue';
export default {
  name: 'TextMarquee',
  components: {
    SanityBlockContent
  },
  props: {
    marqueeText: Array
  },
  computed: {
    existingParams() {
      if (!this.$route.query) return null;
      return Object.keys(this.$route.query).map(key => {
        return `${key}=${this.$route.query[key]}`;
      }).join('&') || null;
    }
  },
  mounted() {
    const elements = this.$el.querySelectorAll('.scroll-text-marquee__text a');
    elements.forEach(el => {
      let href = el.href;
      href += this.existingParams ? `?${this.existingParams}` : '';
      el.href = href;
    });
    this.animate();
  },
  methods: {
    animate() {
      const el = this.$el.querySelector('.scroll-text-marquee__text');
      const elWidth = el.offsetWidth;
      const parentWidth = this.$refs.marquee.offsetWidth;
      let flag = 0;
      setInterval(() => {
        el.style.marginLeft = --flag + 'px';
        if (elWidth === -flag) {
          flag = parentWidth;
        }
      }, 10);
    }
  }
};